import Error from './Error'

// eslint-disable-next-line import/no-unused-modules
export default Error
